<template>
  <v-item-group
    v-model="modelValue"
    multiple
    :class="`d-flex flex-wrap ga-4 ${xs ? 'flex-column' : ''}`"
  >
    <v-item
      v-for="method in tradedPaymentMethods"
      :key="method.code"
      v-slot="{ isSelected, toggle }"
      :value="method.code"
    >
      <button
        v-ripple="!method.mandatory"
        min-width="250"
        :class="buttonClass(method.mandatory ?? false, isSelected)"
        :style="`flex: 1 0 ${smAndUp ? '32%' : '100%'}`"
        @click.prevent="!method.mandatory && toggle && toggle()"
      >
        <span
          ><payment-method :method="method.code" :show-backup="false" width="32" />&nbsp;{{
            method.name
          }}</span
        >
        <v-icon v-if="isSelected"> mdi-check </v-icon>
      </button>
    </v-item>
  </v-item-group>
</template>

<script setup lang="ts">
import { PaymentMethod as PaymentMethodType } from "@tableyeti/merchant-service";
import { useDisplay } from "vuetify";
import { tradedPaymentMethods } from "@/utils/config";

const { xs, smAndUp } = useDisplay();

const modelValue = defineModel<string[]>({
  default: [PaymentMethodType.Visa, PaymentMethodType.Mc],
});

const buttonClass = (disabled: boolean, selected?: boolean) => {
  const classes = {
    "form-disable-enter pa-5 rounded-xl d-flex justify-space-between": true,
    "bg-background cursor-pointer elevation-1": !disabled,
    "bg-transparent border border-purple-4": disabled,
    "bg-pink-4": !disabled && selected,
  };

  return classes;
};
</script>

<style scoped>
button:focus {
  outline: 1px solid rgba(var(--v-theme-purple-4), 0.5);
}
</style>
